import axios from 'axios';
import { useQuery } from 'react-query';

const useGetSecondarySystems = () => {
  const { data, isLoading } = useQuery('secondarysystems', async () => {
    return (await axios.get(`/idcards/secondarysystems`)).data;
  });

  return {
    secondarySystems: data,
    isLoading,
  };
};

export default useGetSecondarySystems;
